import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoDefinirOrcamento from './ContentSolicitacaoFluxoDefinirOrcamento';

const SolicitacaoFluxoDefinirOrcamento = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentSolicitacaoFluxoDefinirOrcamento />
      <Bottom />
    </div>
  );
};

export default SolicitacaoFluxoDefinirOrcamento;
